<mat-action-list class="text-[inherit]">
  <mat-list-item
    (click)="menuItemClicked.emit('preferences')"
    class="border-b md:border-none"
  >
    <mat-icon
      matListItemIcon
      class="bg-blue-500 !text-white !text-[17px] !p-[4px] rounded flex items-center justify-center"
      >tune</mat-icon
    >
    <div matListItemTitle>Preferences</div>
  </mat-list-item>

  <mat-list-item
    (click)="menuItemClicked.emit('account')"
    class="border-b md:border-none"
  >
    <mat-icon
      matListItemIcon
      class="bg-yellow-500 !text-white !text-[17px] !p-[4px] rounded flex items-center justify-center"
      >person</mat-icon
    >
    <div matListItemTitle>Account</div>
  </mat-list-item>
  <mat-list-item
    *ngIf="!authService.isDemo"
    (click)="menuItemClicked.emit('prefund_pro')"
    class="border-b md:border-none"
  >
    <mat-icon
      matListItemIcon
      class="bg-purple-500 !text-white !text-[17px] !p-[4px] rounded flex items-center justify-center"
      >star</mat-icon
    >
    <div matListItemTitle>Prefund Pro</div>
  </mat-list-item>
  <mat-list-item
    (click)="menuItemClicked.emit('advanced')"
    class="border-b md:border-none"
  >
    <mat-icon
      matListItemIcon
      class="bg-red-500 !text-white !text-[17px] !p-[4px] rounded flex items-center justify-center"
      >code</mat-icon
    >
    <div matListItemTitle>Advanced</div>
  </mat-list-item>
  <mat-list-item (click)="menuItemClicked.emit('about')">
    <mat-icon
      matListItemIcon
      class="bg-green-500 !text-white !text-[17px] !p-[4px] rounded flex items-center justify-center"
      >badge</mat-icon
    >
    <div matListItemTitle>About</div>
  </mat-list-item>
</mat-action-list>
